import { useContext, useState } from 'react';
import * as React from 'react';
import {
  List, ListItem, ListItemButton, ListItemText,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import type {
  BassSettings,
  GuitarSettings,
} from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';

const TUNINGS = {
  standard: 'home.input.dialog.tuning.standard',
  'drop-d': 'home.input.dialog.tuning.drop_d',
  'open-d': 'home.input.dialog.tuning.open_d',
  'open-e': 'home.input.dialog.tuning.open_e',
  'open-g': 'home.input.dialog.tuning.open_g',
  'open-a': 'home.input.dialog.tuning.open_a',
  dadgad: 'home.input.dialog.tuning.dadgad',
  dgcgcd: 'home.input.dialog.tuning.dgcgcd',
  'half-step-down': 'home.input.dialog.tuning.half_step_down',
  'full-step-down': 'home.input.dialog.tuning.full_step_down',
  nashville: 'home.input.dialog.tuning.nashville',
};

const BASS_TUNINGS = {
  standard: 'home.input.dialog.tuning.bass.standard',
  'drop-d': 'home.input.dialog.tuning.bass.drop_d',
  '5-string-low': 'home.input.dialog.tuning.bass.5_string_low',
  '5-string-high': 'home.input.dialog.tuning.bass.5_string_high',
  '6-string': 'home.input.dialog.tuning.bass.6_string',
};

// Using tss-react's makeStyles
const useStyles = makeStyles()(() => ({
  container: {
    width: '300px',
    height: '200px',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.23)',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  list: {
    flexGrow: 1,
    overflowY: 'auto', // to make the list scrollable
  },
}));

export interface TuningProps {
  setCurrentStep: (step: number) => void;
}

const Tuning: React.FC<TuningProps> = ({ setCurrentStep }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { settings, setSettings } = useContext(TranscriptionDialogContext);
  const [selectedTuning, setSelectedTuning] = useState<
    GuitarSettings['tuning'] | BassSettings['tuning']
  >('standard');
  const tunings = settings.instruments[0] === 'bass' ? BASS_TUNINGS : TUNINGS;

  const handleTuningChange = (tuning: GuitarSettings['tuning']) => {
    setSelectedTuning(tuning);
    setSettings({ tuning }, settings.instruments[0]);
    setCurrentStep(4);
  };
  return (
    <div className={classes.container}>
      <List className={classes.list}>
        {Object.entries(tunings).map(([key, value]) => {
          return (
            <ListItem key={key} disablePadding>
              <ListItemButton
                id={`btn_wizard_tuning_${key}`}
                selected={selectedTuning === key}
                onClick={() => handleTuningChange(key as GuitarSettings['tuning'])}
              >
                <ListItemText primary={t(value)} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default Tuning;
